
import React from "react";

import { SearchIconProps } from "./SearchIcon.types";

const IconDownload: React.FC<SearchIconProps> = ({ colourFill }) => {

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.7345 14.4865L12.8629 11.6364C15.1051 8.76659 14.8691 4.67813 12.2926 2.10319C10.9355 0.746929 9.126 0 7.19852 0C5.27105 0 3.46159 0.746929 2.10449 2.10319C0.747388 3.45946 0 5.26781 0 7.1941C0 9.12039 0.747388 10.9287 2.10449 12.285C3.46159 13.6413 5.27105 14.3882 7.19852 14.3882C8.79164 14.3882 10.3651 13.8575 11.6238 12.855L14.4757 15.7445C14.6527 15.9214 14.8691 16 15.1051 16C15.3411 16 15.5575 15.9017 15.7345 15.7445C16.0885 15.4103 16.0885 14.8403 15.7345 14.4865ZM12.6269 7.1941C12.6269 8.64865 12.0565 10.0049 11.0338 11.027C10.0111 12.0491 8.6343 12.6192 7.19852 12.6192C5.76275 12.6192 4.38599 12.0491 3.36325 11.027C2.3405 10.0049 1.77013 8.62899 1.77013 7.1941C1.77013 5.73956 2.3405 4.38329 3.36325 3.36118C4.38599 2.33907 5.76275 1.76904 7.19852 1.76904C8.65396 1.76904 10.0111 2.33907 11.0338 3.36118C12.0565 4.38329 12.6269 5.73956 12.6269 7.1941Z" fill={colourFill}/>
        </svg>
    )
} 


export default IconDownload;

